// Runs callback once, the first time any of the elements comes within margin
// of the screen: for work that can wait until it's about to be seen
const whenNearScreen = (elements, callback, margin = '600px') => {
  if (!('IntersectionObserver' in window)) {
    callback();
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    if (entries.some(entry => entry.isIntersecting)) {
      observer.disconnect();
      callback();
    }
  }, { rootMargin: margin });

  Array.prototype.forEach.call(elements, el => observer.observe(el));
};

export default whenNearScreen;
